import * as React from 'react';
import s from './search-result.scss';
import type { ISolutionGridWrapperProps } from '../../solution-grid-wrapper/solution-grid-wrapper';
import { SolutionGridWrapper } from '../../solution-grid-wrapper/solution-grid-wrapper';
import { Box, Heading } from '@wix/design-system';
import { FluidContainer } from '../../FluidContainer';
import { BackButton } from '../../back-button';
import { SearchBoxContainer } from '../../search-box';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { composer } from '../../../component-decorators/composer';
import { SolutionGridLayout } from '@wix/app-market-collection-widget';
import { TerminatorContainer } from '../terminator';

export interface ISearchResultProps extends Partial<WithTranslationProps> {
  query: string;
  locale: string;
  isMobile: boolean;
  numOfResults?: number;
  solutionGridWrapperProps: ISolutionGridWrapperProps;
}

export const SearchResult = composer()
  .withTranslation()
  .compose(
    ({
      locale,
      query,
      isMobile,
      solutionGridWrapperProps,
      numOfResults,
      t,
    }) => {
      return (
        <>
          <FluidContainer className={s.pageSettingsGrey} isWide={true}>
            <Box
              maxWidth="1248px"
              minWidth={isMobile ? 'none' : '864px'}
              direction="vertical"
              margin="0 auto 33px"
              padding={isMobile ? '0 12px' : '0 48px'}
            >
              <Box marginBottom="12px">
                <BackButton size="medium" />
              </Box>
              <Box align="space-between" marginBottom="24px">
                <Box
                  direction="vertical"
                  align="left"
                  dataHook="search-result-header"
                >
                  <Box marginTop="8px">
                    <div data-testid="search-result-header">
                      <Heading
                        appearance="H2"
                        dataHook="search-result-header-content-subtitle"
                      >
                        {numOfResults}{' '}
                        {t('searchResultHeaderContent.searchResult')} {t(query)}
                      </Heading>
                    </div>
                  </Box>
                </Box>
                {!isMobile && (
                  <Box width="294px">
                    <SearchBoxContainer
                      isInMenu={false}
                      isExpandable={false}
                      isInHeader={false}
                      isInSearchPage={true}
                      locale={locale}
                      value={query}
                      searchLocation="search_result_page"
                    />
                  </Box>
                )}
              </Box>
              <Box
                marginTop={isMobile ? '-32px' : '-38px'}
                marginBottom={isMobile ? '18px' : '34px'}
              >
                <TerminatorContainer
                  fullWidth={true}
                  term={query}
                  isMobile={isMobile}
                />
              </Box>
              <SolutionGridWrapper
                {...solutionGridWrapperProps}
                referralSectionName="search-result"
                layout={SolutionGridLayout.INTEGRATIONS}
              />
            </Box>
          </FluidContainer>
        </>
      );
    },
  );
